import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Utils from "../../Classes/Utils";
import { GetAddress, GetOrderDetails } from "../Data";
import AddressBook from "./AddressBook/AddressBook";
import OrderDetails from "./Orders/OrderDetails";
import { Global } from "../Variables/Global";
import Cookies from "js-cookie";

const Account = () => {
  const [showActive, setShowActive] = useState("Orders");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [modalData, setModalData] = useState(null);
  const [show, setShow] = useState(false);
  const [orders, setOrders] = useState([]);
  const [addressBook, setAddressBook] = useState({});
  const navigate = useNavigate();
  const token = Cookies.get("CustomerToken");

  const HandleLogout = () => {
    Cookies.remove("CustomerToken", {
      expires: new Date(),
      path: '/'
    });
    Cookies.remove("User");
    Cookies.remove("WishList");
    Cookies.remove("Cart");
    Cookies.remove("Subscribe");
    Cookies.remove("Number");
    navigate("/Authentication");
  };

  const GetAddressBookDetails = () => {
    // const getItem = Cookies.get("Number") !== undefined;
    if (Cookies.get("Number") !== undefined) {
      // var CustomerId = Utils.decrypt(localStorage.getItem("Number"));
      var CustomerId = Cookies.get("Number");
      GetAddress(CustomerId, token).then((res) => {

        setAddressBook(res);
        if (res?.CityId) {
          fetch(Global.API_URL + "Country/GetCitiyNameById/" + res.CityId, {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Authorization:": `Bearer ${token}`,
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": Global.API_URL,
            },
          })
            .then((response) => {
              return response.json();
            })
            .then((Result) => {
              setCity(Result[0].CityName);
              if (Result[0].CountryCode === "UAE") {
                setCountry("United Arab Emirates");
              } else if (Result[0].CountryCode === "LB") {
                setCountry("Lebanon");
              }
            });
        }
      });
    }
  };
  const GetOrderDetailsByCustomerId = () => {
    // const getItem = Cookies.get("Number") !== undefined;

    if (Cookies.get("Number") !== undefined) {
      const id = Cookies.get("Number");
      GetOrderDetails(id, token).then((result) => {
        setOrders(result);
      });
    }
  };

  useEffect(() => {

    if (Cookies.get("CustomerToken") === undefined) {
      navigate("/Authentication");
    }
    // getCustomerInfo();
    GetOrderDetailsByCustomerId();
    GetAddressBookDetails();
  }, []);
  return (
    <>
      <div className="breadcrumb-area mb-5">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="breadcrumb-container HomeShop">
                <ul>
                  <li>
                    <a href="index.html">
                      <i className="fa fa-home"></i> Home
                    </a>
                  </li>
                  <li className="active">My Account</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-account-section section position-relative mb-5 fix">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-lg-3 col-12">
                  <div className="myaccount-tab-menu nav" role="tablist">
                    <a
                      href="#orders"
                      data-bs-toggle="tab"
                      className="RemUnderline active"
                      onClick={() => setShowActive("Orders")}
                    >
                      <i className="fa fa-cart-arrow-down"></i>Orders
                    </a>

                    <a
                      href="#address-edit"
                      data-bs-toggle="tab"
                      className="RemUnderline"
                      onClick={() => setShowActive("Address")}
                    >
                      <i className="fa fa-map-marker"></i>Address
                    </a>

                    <a
                      href="#account-info"
                      data-bs-toggle="tab"
                      className="RemUnderline"
                      onClick={() => setShowActive("account-info")}
                    >
                      <i className="fa fa-user"></i>Shipping Details
                    </a>

                    <a className="RemUnderline" onClick={HandleLogout}>
                      <i className="fa fa-sign-out"></i> Logout
                    </a>
                  </div>
                </div>

                <div className="col-lg-9 col-12">
                  <div className="tab-content" id="myaccountContent">
                    <div
                      className={`tab-pane fade ${showActive.includes("Orders") ? "show active" : ""
                        } `}
                      id="orders"
                      role="tabpanel"
                    >
                      {orders.length > 0 ? (
                        <div className="myaccount-content">
                          <h3 className="mb-4">My Orders</h3>

                          <div className="row">
                            {orders.map((order, index) => (
                              <div key={index} className="col-12 mb-3">
                                <div className="card shadow-sm border-0">
                                  <div className="card-body">

                                    {/* Header */}
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <div>
                                        <h6 className="mb-0">
                                          Order #{order.OrderNumber || order.OrderId}
                                        </h6>
                                        <small className="text-muted">
                                          {new Date(order.Date).toLocaleString()}
                                        </small>
                                      </div>

                                      <span className={`badge ${order.OrderStatusName === "Completed" ? "bg-success" :
                                          order.OrderStatusName === "Pending" ? "bg-warning" :
                                            "bg-secondary"}`}>
                                        {order.OrderStatusName}
                                      </span>
                                    </div>

                                    {/* Summary */}
                                    <div className="row mt-3">
                                      <div className="col-md-4">
                                        <b>Total:</b> {order.Currency} {order.OrderTotal}
                                      </div>
                                      <div className="col-md-4">
                                        <b>Payment:</b> {order.PaymentMethodName}
                                      </div>
                                      <div className="col-md-4 text-md-end">
                                        <button
                                          className="btn btn-sm"
                                          style={{
                                            borderColor: "#115938",
                                            color: "#115938",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#115938";
                                            e.currentTarget.style.color = "#fff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#115938";
                                          }}
                                          onClick={() => {
                                            setModalData(order);
                                            setShow(true);
                                          }}
                                        >
                                          View Details
                                        </button>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                          {show && (
                            <OrderDetails
                              modalData={modalData}
                              show={show}
                              setShow={setShow}
                            />
                          )}
                        </div>
                      ) : (
                        <h4>No Orders Yet</h4>
                      )}

                    </div>

                    <div
                      className={`tab-pane fade ${showActive.includes("Address") ? "show active" : ""
                        } `}
                      id="address-edit"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        {addressBook ? (
                          <address>
                            <p>
                              <strong>
                                {addressBook.FirstName +
                                  " " +
                                  addressBook.LastName}
                              </strong>
                            </p>
                            <p>{country}</p>
                            <p>{city}</p>
                            <p>{addressBook.Address1}</p>
                            <p>{addressBook.Address2}</p>
                            <p>Mobile: {addressBook.PhoneNumber}</p>
                          </address>
                        ) : (
                          <h3>No Billing Address</h3>
                        )}
                      </div>
                    </div>

                    <div
                      className={`tab-pane fade ${showActive.includes("Details") ? "show active" : ""
                        } `}
                      id="account-info"
                      role="tabpanel"
                    >
                      <div className="myaccount-content">
                        <h3>Shipping Details</h3>
                        <div className="account-details-form">
                          <AddressBook />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;
